<img
  width="100%"
  [style.max-height]="maxHeight"
  [style.min-height.px]="minHeight"
  [src]="src"
  (load)="onLoad($event)"
/>